export default function TextAreaField({
  label,
  required,
  value,
  onChange,
  placeholder,
}) {
  return (
    <div className="mb-6">
      <label
        htmlFor="message"
        className="block text-sm font-medium mb-1 text-gray-900"
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <textarea
        id="message"
        rows="4"
        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      ></textarea>
    </div>
  );
}
